// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"05da56ad","455":"5e46299d","977":"4cc2bfbd"}[chunkId] + ".chunk.js";
};